$(function() {
    const _areasub = $("#areasub_id"),
        _areasubs = JSON.parse($("#areasubsJson").val()),
        _area_id = $("#area_id").val();

    const changeArea = id => {
        _areasub.children().remove();

        if (id) {
            const _rows = _areasubs[id],
                _selected_areasub_id = $("#selected_areasub_id").val();

            _areasub.append(
                $("<option>", {
                    value: "",
                    text: ""
                })
            );

            for (let key in _rows) {
                _areasub.append(
                    $("<option>", {
                        value: key,
                        text: _rows[key]
                    })
                );
            }

            _areasub.val(_selected_areasub_id);
        }
    };

    changeArea(_area_id);
    $("#area_id").on("change", function() {
        const _id = $(this).val();
        changeArea(_id);
    });
});
